import React, { useState, useCallback, useRef, useEffect } from 'react';
import { motion } from 'framer-motion';
import AnimatedWaves from '../../components/AnimatedWaves';
import axios from 'axios';

const AgentPlayground = () => {
  const [isSTTActive, setIsSTTActive] = useState(false);
  const [isTTSPlaying, setIsTTSPlaying] = useState(false);
  const [transcript, setTranscript] = useState('');
  const [aiResponse, setAiResponse] = useState('');
  const recognitionRef = useRef(null);
  const audioRef = useRef(new Audio());

  const initializeRecognition = useCallback(() => {
    if (!('webkitSpeechRecognition' in window)) {
      alert('Speech recognition is not supported in this browser.');
      return null;
    }
    const instance = new window.webkitSpeechRecognition();
    instance.continuous = true;
    instance.interimResults = false;
    instance.lang = 'en-IN';

    instance.onresult = (event) => {
      const last = event.results.length - 1;
      const text = event.results[last][0].transcript;
      setTranscript(text);
      handleAiResponse(text);
    };

    instance.onerror = () => {
      setIsSTTActive(false);
    };

    instance.onend = () => {
      setIsSTTActive(false);
    };

    return instance;
  }, []);

  const handleAiResponse = async (text) => {
    try {
      const response = await axios.post('/api/ai-response', { prompt: text });
      setAiResponse(response.data.response);
    } catch (error) {
      console.error('Error fetching AI response:', error);
    }
  };

  const toggleListening = useCallback(() => {
    if (isSTTActive) {
      if (recognitionRef.current) {
        recognitionRef.current.stop();
      }
      setIsSTTActive(false);
    } else {
      setIsSTTActive(true);
      setTranscript('');
      setAiResponse('');
      if (!recognitionRef.current) {
        recognitionRef.current = initializeRecognition();
      }
      if (recognitionRef.current) {
        recognitionRef.current.start();
      }
    }
  }, [isSTTActive, initializeRecognition]);

  useEffect(() => {
    const audio = audioRef.current;
    audio.onplay = () => setIsTTSPlaying(true);
    audio.onended = () => setIsTTSPlaying(false);
    return () => {
      audio.onplay = null;
      audio.onended = null;
    };
  }, []);

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      <motion.h1
        className="text-4xl font-bold text-gray-800 mb-6"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        Agent Playground
      </motion.h1>
      <div className="w-full max-w-3xl p-6 bg-transparent rounded-lg ">
        <AnimatedWaves isSTTActive={isSTTActive} isTTSPlaying={isTTSPlaying} />
        <div className="mt-4">
          <p className="text-lg text-gray-600">
            <strong>You said:</strong> {transcript || '(Waiting for input...)'}
          </p>
          {aiResponse && (
            <p className="text-lg text-gray-600 mt-2">
              <strong>AI Response:</strong> {aiResponse}
            </p>
          )}
        </div>
        {/* <div className="mt-6 flex justify-center">
          <motion.button
            className={`px-6 py-3 rounded-lg text-white font-semibold ${
              isSTTActive ? 'bg-red-500' : 'bg-blue-500'
            }`}
            onClick={toggleListening}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            {isSTTActive ? 'Stop Listening' : 'Start Listening'}
          </motion.button>
        </div> */}
      </div>
    </div>
  );
};

export default AgentPlayground;

